import React, {useState} from 'react';
import ContentRecord from "@/components/resolve/ContentRecord";

export default function ({
                             title,
                             data,
                             canClose = true,
                             defaultOpen = false,
                         }: {
    title?: string;
    data: any;
    defaultOpen?: boolean;
    canClose?: boolean;
    setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    contentWhenClosed?: string | null;
}) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const handleToggle = (state) => {
        setIsOpen(!isOpen)
    };

    console.log(data);

    let keys = Object.keys(data);
    keys = keys.sort();

    return (
        <div className="expandable-records w-full flex flex-col animate__animated animate__fadeIn">
            {canClose && (
                <button className="flex w-full justify-between my-2 cursor-pointer"  onClick={handleToggle} type="button">
                    <h3 className="text-lg">{title}</h3>
                    <div
                        className="rounded px-2 py-1 text-sm flex flex-row justify-between items-center">
                        <span className="me-3">+{data.length}</span>
                        <i className="mio">{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
                    </div>
                </button>
            )}
            {!isOpen && <hr/>}
            <div className={'animate__animated animate__fadeIn  ' + (isOpen ? 'block' : 'hidden')}>
                <div>
                    {keys.map((key, index) => {
                        return (
                            <div className="child-record-card border inverse-bg-black mb-4 border-primary-light rounded"
                                 key={`content-record-${data[key].ID}`}>
                                <ContentRecord
                                    record={data[key]}
                                    mode="card"
                                    isOpen={false}
                                    showParentRecord={false}
                                />
                            </div>

                        );
                    })}
                </div>
            </div>
        </div>
    );
}
